import { Qr } from 'component/Qr'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'
import { buildViewLink } from 'type/Inference'
import css from './QrPane.module.scss'

export const QrPane = observer(() => {
  const { tablet } = store.frame
  const { carousel, extend } = store.carousel
  const inference_id = carousel.item?.inference_id
  const complete = !!carousel.item?.complete
  const link = inference_id ? buildViewLink(inference_id) : ''

  if (!complete || !link || extend || tablet) return null

  return <Vertical className={css.pane} gap={16} pad={16} tall opposite>
    <Space pad={[16, 0]}>
      <Qr link={link} size={200} />
    </Space>

    <Typo size={16} pre center>
      {i18n('PointYourCameraToShare')}
    </Typo>
  </Vertical>
})
